import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import { ChartPie, Clock, CreditCard, Grid2x2, MapPin, Shield } from 'lucide-react';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as PayoutsIcon } from '../../../assets/icons/payouts.svg';
import './styles.scss';

interface RentabilityOption {
  id: string;
  labelKey: string;
  descKey: string;
  tooltipKey: string;
  route: string;
  icon: React.ReactNode;
}

const pm = Routes.PAYMENT_METHODS;

const Rentability = () => {
  const history = useHistory();

  const options: RentabilityOption[] = [
    {
      id: 'payment-methods',
      labelKey: 'menu.subItem.PAYMENT_METHODS',
      descKey: 'rentability.paymentMethods.desc',
      tooltipKey: 'rentability.paymentMethods.tooltip',
      route: `${pm}?tab=payment-methods`,
      icon: <CreditCard className="rentability-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
    {
      id: 'payouts',
      labelKey: 'menu.subItem.RENTABILITY_PAYOUTS',
      descKey: 'rentability.payouts.desc',
      tooltipKey: 'rentability.payouts.tooltip',
      route: `${pm}?tab=payouts`,
      icon: <PayoutsIcon className="rentability-hub__icon rentability-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'coverage',
      labelKey: 'menu.subItem.RENTABILITY_COVERAGE',
      descKey: 'rentability.coverage.desc',
      tooltipKey: 'rentability.coverage.tooltip',
      route: `${pm}?tab=coverage`,
      icon: <MapPin className="rentability-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
    {
      id: 'calculator',
      labelKey: 'menu.subItem.RENTABILITY_CALCULATOR',
      descKey: 'rentability.calculator.desc',
      tooltipKey: 'rentability.calculator.tooltip',
      route: `${pm}?tab=calculator`,
      icon: <Grid2x2 className="rentability-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
    {
      id: 'accreditation-times',
      labelKey: 'menu.subItem.RENTABILITY_ACCREDITATION_TIMES',
      descKey: 'rentability.accreditation.desc',
      tooltipKey: 'rentability.accreditation.tooltip',
      route: `${pm}?tab=accreditation-times`,
      icon: <Clock className="rentability-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
    {
      id: 'installments',
      labelKey: 'menu.subItem.RENTABILITY_INSTALLMENTS',
      descKey: 'rentability.installments.desc',
      tooltipKey: 'rentability.installments.tooltip',
      route: `${pm}?tab=installments`,
      icon: <ChartPie className="rentability-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
    {
      id: 'threed-secure',
      labelKey: 'menu.subItem.RENTABILITY_THREE_D_SECURE',
      descKey: 'rentability.threeDSecure.desc',
      tooltipKey: 'rentability.threeDSecure.tooltip',
      route: `${pm}?tab=threed-secure`,
      icon: <Shield className="rentability-hub__icon" strokeWidth={1.5} aria-hidden />,
    },
  ];

  return (
    <div className="rentability-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_RENTABILIDAD')} subtitle={l('rentability.subheadline')} />
      <AlertMessages />
      <Card className="rentability-hub__card">
        <div className="rentability-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="rentability-hub__accent-line" />}>
              <button
                type="button"
                className="rentability-hub__item"
                role="listitem"
                onClick={() => history.push(option.route)}
              >
                <div
                  className="rentability-hub__info"
                  onClick={e => e.stopPropagation()}
                  onKeyDown={e => e.stopPropagation()}
                >
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="rentability-hub__info-icon" aria-hidden />}
                  />
                </div>
                <div className="rentability-hub__icon-wrap">{option.icon}</div>
                <div className="rentability-hub__label">{l(option.labelKey)}</div>
                <div className="rentability-hub__desc">{l(option.descKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Rentability;
